module.exports = __webpack_public_path__ + "static/media/merx-logo.cac8addf.png";